<template>
  <StatusCard
    :cor="card.situacao.cor"
  >
    <div style="display:flex; flex-flow: row nowrap;">
      <ExtratoAutorizacaoItem
        :row="card"
        style="flex: 1;"
      />
      <StatusItem
        :column=" { field: 'situacao', title: 'Situação' }"
        :row="card"
        style="flex: 1; position: relative; top: 10px"
      />
      <DataItem
        :column="{ field: 'dataSolicitacao', title: 'Data solicitação' }"
        :row="card.guia"
        style="flex: 0.5; position: relative; top: 10px"
      />
      <DataItem
        :column="{ field: 'dataAutorizacao', title: 'Data autorização' }"
        :row="card.guia"
        style="flex: 0.5; position: relative; top: 10px"
      />
      <DataItem
        :column="{ field: 'dataValidade', title: 'Data validade' }"
        :row="card.guia"
        style="flex: 0.5; position: relative; top: 10px"
      />
      <AcoesWidget v-if="showWidgetActions" :row="card" :preloadWidget="preloadWidget"/>
    </div>
  </StatusCard>
</template>
<script>
import DataItem from '@/components/listagemColumn/DataItem.vue'
import ExtratoAutorizacaoItem from '@/components/listagemColumn/ExtratoAutorizacaoItem'
import StatusCard from '@/components/cards/StatusCard'
import StatusItem from '@/components/listagemColumn/StatusItem'
import AcoesWidget from '@/components/TemplateSolicitacao/componentes/AcoesWidget.vue'

export default {
  name: 'ListaExtratoAutorizacaoCard',
  components: { AcoesWidget, DataItem, ExtratoAutorizacaoItem, StatusCard, StatusItem },
  props: {
    card: {},
    showWidgetActions: {
      type: Boolean,
      default: false
    },
    preloadWidget: {
      type: Function
    }
  }
}
</script>
